import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { Tracking } from "../../../services/Tracking";

const POLL_INTERVAL_MS = 3000;

export const usePixV2 = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator();

  const { data: fatura, isError: isFaturaError } = useConsultarFatura(
    uuidAgendamento ?? "",
  );
  const { data: agendamento, refetch } = useAgendamentoPorId(
    uuidAgendamento ?? "",
  );

  const pagamento = fatura?.content?.find(
    (f) => f.status === StatusPagamentoEnum.pending,
  );

  useEffect(() => {
    if (!isFaturaError) return;
    Tracking.error("mapa:agendamento/pagamento/pix:consultar-fatura-falhou");
  }, [isFaturaError]);

  useEffect(() => {
    if (!uuidAgendamento) return;

    const interval = setInterval(() => refetch(), POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [uuidAgendamento, refetch]);

  useEffect(() => {
    if (agendamento?.status !== StatusAgendamentoEnum.PAGO) return;

    navigate(
      `/agendamento/${uuidAgendamento}/pagamento/pix/confirmacao-pagamento`,
    );
  }, [agendamento?.status, uuidAgendamento, navigate]);

  function acessarFatura() {
    navigate(`/agendamento/${uuidAgendamento}/fatura`);
  }

  return {
    stepIndicator,
    pagamento,
    acessarFatura,
  };
};
